import { keyframes, styled } from '@mui/system';

const dotFlashing = keyframes`
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
`;

const Dot = styled('span')({
  animation: `${dotFlashing} 1s infinite linear`,
  '&:nth-of-type(1)': {
    animationDelay: '0s',
  },
  '&:nth-of-type(2)': {
    animationDelay: '0.2s',
  },
  '&:nth-of-type(3)': {
    animationDelay: '0.4s',
  },
});

const SavingDots = () => {
  return (
    <div className='flex items-center'>
      <p className='text-xl text-[#1B4332] font-semibold'>
        Saving
        <Dot>.</Dot>
        <Dot>.</Dot>
        <Dot>.</Dot>
      </p>
    </div>
  );
};

export default SavingDots;
